import React, { useContext } from "react"
import { useSelector } from "react-redux"
import { testTakerRQ } from "store/hooks"
import { CreateTestTakersContext } from "../CreateTestTakerContext"
import allClassess from "mock/classess"
import { Link } from "react-router-dom"
import { app } from "router/routes"

const useFormFields = () => {
    const { grades, tClasses } = useSelector(state => state.testTaker)
    const { schools } = useContext(CreateTestTakersContext)
    const { affiliations } = useSelector(state => state.affiliation)

    const { data: allGrades } = testTakerRQ.useGetAllGrades({ enabled: true })

    const fields =
        React.useMemo(
            () =>
                [
                    {
                        name: "school",
                        placeholder: "בית ספר",
                        component: "autoComplete",
                        minWidth: 100,
                        options: schools,
                        getOptionLabel: (opt) => `${opt.name} ${opt.area ? `- ${opt.area}` : ""}`,
                        noOptionsText:
                            <div>
                                אם ביה"ס שלכם לא נמצא ברשימה
                                {" "}
                                <Link to={app.contactUs}>כתבו אלינו</Link>
                            </div>,
                        systemUI: true,
                        required: true,
                        fullWidth: true,
                        isOptionEqualToValue: (option, value) => option.id === value.id
                    },
                    {
                        name: "grade",
                        placeholder: "שכבה",
                        minWidth: 100,
                        component: "autoComplete",
                        className: "_child__grade",
                        systemUI: true,
                        options: allGrades,
                        required: true
                    },
                    {
                        name: "t_class",
                        placeholder: "מספר כיתה",
                        minWidth: 100,
                        component: "autoComplete",
                        className: "_child__t_class",
                        systemUI: true,
                        options: allClassess,
                        required: true,
                        isOptionEqualToValue: (option, value) => option.id === value.id
                    },
                    {
                        name: "file",
                        component: "uploadFile",
                        label: "רשימת התלמידים בפורמט exel",
                        type: "exel",
                        showCleanIcon: true
                    }
                ]
            , [grades, schools, allGrades]
        );


    return fields
}

export default useFormFields 